import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import highs_loader from '../node_modules/highs/build/highs.js';


highs_loader({
    // In a browser, one can load the wasm file from github
    // locateFile: (file) => "https://lovasoa.github.io/highs-js/" + file
    locateFile: (file) => file
}).then((highs)=> {
    console.log(highs.solve);
    window.highs = highs;
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();
},(highs) => {
    console.log('Error');
});

